import type { BatchListRow } from '@ctcells/contract'
import { t } from '@ctcells/i18n'

import type { Column } from '../../atoms/DataTable.tsx'
import { ShortId } from '../../atoms/ShortId.tsx'
import { COMPACT_BATCH_ID } from '../listColumnPriority.ts'

/**
 * 「작업 ID」 첫 열 — 작업 목록과 이력이 **같은 함수**를 쓴다(두 표가 같은 값을 다르게 말하지 않게).
 *
 * 🔴 **첫 열은 작업 ID 다**(eric 2026-09-22 「작업 데이터인데 작업 ID 가 가장 먼저 와야지」).
 *    행을 여는 링크도 이 칸이다 — 첫 칸이 진짜 `button` 이어야 키보드로 갈 수 있다(§11-4-7).
 *
 * ## 줄이기 — 서랍이 열려 폭이 모자랄 때만 (eric 2026-09-28 「줄여」)
 *
 * - **넉넉하면 36자 전체 그대로다.** 서랍이 닫힌 목록은 종전과 같다
 * - 폭이 모자라면 **빼기 전에 먼저** 앞 8자 + 「…」로 준다(`compact` · `columnFit.ts` 「줄인 꼴」 단계).
 *   원값은 툴팁(`title`)과 보조기술 글자로 그대로 남고(`ShortId`), 서랍 머리에는 전체 ID 와 복사 단추가 선다
 * - ⚠ 2026-09-22 eric 의 「짤리는데? 숨김 처리하면 안 되지」는 이 결정으로 **서랍 열림(폭 모자람) 때에 한해**
 *   뒤집혔다. 넉넉한 폭에서 줄이지 마라. **상시 작업 줄(`shell/BatchStrip`)의 작업 ID 는 전체 그대로다** — 여기와 무관하다
 */
export function batchIdColumn(onOpenBatch?: (batchId: string) => void): Column<BatchListRow> {
  return {
    key: 'batch',
    // 🔴 값이 작업 ID 라 머리도 「작업 ID」다(2026-09-22)
    header: t('column.batchId'),
    nowrap: true,
    /*
     * 🔴 **내용 폭만 쓴다**(eric 2026-09-30 「작업 ID와 결과 사이에 공간이 너무 많은데」). 자동 배분이면
     *    36자 UUID 열이 남는 폭을 제일 많이 받아 다음 열이 멀리 떨어진다. 넉넉할 때 36자 전체인 것은 그대로다
     */
    width: 'fit',
    sort: 'text',
    sortValue: (row) => row.batch_id,
    cell: (row) =>
      onOpenBatch === undefined ? (
        <span className="mono">{row.batch_id}</span>
      ) : (
        <button className="lnk mono" onClick={() => onOpenBatch(row.batch_id)} type="button">
          {row.batch_id}
        </button>
      ),
    compact: {
      priority: COMPACT_BATCH_ID,
      cell: (row) =>
        onOpenBatch === undefined ? (
          <ShortId value={row.batch_id} />
        ) : (
          <button className="lnk" onClick={() => onOpenBatch(row.batch_id)} type="button">
            <ShortId value={row.batch_id} />
          </button>
        ),
    },
  }
}
